<style lang="scss" src='./Shrub.scss' scoped></style>
<template src="./Shrub.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getShrubs,
  postShrubs,
  editShrubs
} from '@/api/index';
import i18n from '../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Shrub',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      typesAvailable: [],
      newActive: false,
      editType: null,
      typeName: null,
      loading: false,
    };
  },
  computed: {
    orderedTypes() {
      if (this.typesAvailable && this.typesAvailable.length > 0) {
        let getName = this.getLabel;
        return this.typesAvailable.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

  methods: {
    getLabel(item) {
      return item.name;
    },

    showNewModal() {
      this.newActive = true;
      this.typeName = null;
      this.$bvModal.show('modal-add-shrub')
    },

    showEditModal(item) {
      this.loading = false;
      this.editType = item;
      this.typeName = item.name;
      this.newActive = false;
      this.$bvModal.show('modal-add-shrub');
    },
    
    async saveType(){
      this.loading = true;
      if(this.typeName){

        let data = {
          name: this.typeName,
        };

        if(this.newActive) {

          postShrubs(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-shrub');
          })
        } else {
          editShrubs(data, this.editType.shrub_type_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-shrub');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadAvailableTypes();
    },

    loadAvailableTypes() {
      getShrubs().then((resp) => {
        if (resp.shrub_types && resp.shrub_types.length) {
          this.typesAvailable = resp.shrub_types.map(type => ({...type, selected: false}));
        } else {
          this.typesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Shrubs");
      this.$analytics.logEvent("web_settings_shrubs");
    }

    this.loadData();
  },
};

</script>
